module.exports = __webpack_public_path__ + "img/multiboard.7951bc03.jpg";